import {
    RECURRENCE,
    INDICIAIRE as INDICIAIRE_FIELD,
    MANTY_STATUS,
    RETIREMENT_SYSTEM,
} from 'routes/HumanResourcesModule/business/definitions';

export enum RecurrenceEnum {
    RECURRENT = 'recurrent',
    NON_RECURRENT = 'non_recurrent',
}

export const NON_RENSEIGNE = 'Non renseigné';

export enum MantyStatus {
    TITULAIRE = 'titulaire',
    FONCTIONNAIRE_STAGIAIRE = 'fonctionnaire_stagiaire',
    CONTRACTOR = 'contractor',
    SUBSTITUTE_CONTRACTOR = 'substitute_contractor',
    WAITING_FOR_TITULAIRE_CONTRACTOR = 'waiting_for_titulaire_contractor',
    SEASONAL_CONTRACTOR = 'seasonal_contractor',
    ACTIVITY_INCREASE_CONTRACTOR = 'activity_increase_contractor',
    VACATAIRE = 'vacataire',
    ASSISTANTE_MATERNELLE = 'assistante_maternelle',
    EMPLOI_AIDE = 'emploi_aide',
    INTERN = 'intern',
    APPRENTICE = 'apprentice',
    ELECTED_OFFICIAL = 'elected_official',
    OTHER = 'other',
}

export enum RetirementSystem {
    CNRACL = 'cnracl',
    IRCANTEC = 'ircantec',
}

export enum IndiciaireEnum {
    INDICIAIRE = 'indiciaire',
    NON_INDICIAIRE = 'non_indiciaire',
}

export const hrMappingFieldEnumAssociation = {
    [RECURRENCE]: RecurrenceEnum,
    [INDICIAIRE_FIELD]: IndiciaireEnum,
    [MANTY_STATUS]: MantyStatus,
    [RETIREMENT_SYSTEM]: RetirementSystem,
};

export const humanizedRecurrentValues = {
    [RecurrenceEnum.RECURRENT]: 'Récurrent',
    [RecurrenceEnum.NON_RECURRENT]: 'Non-récurrent',
};
